import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { fetchJobs } from './store/actions';
import { lastUpdatedSelector, isAnyJobInProgressSelector } from './store/selectors';

const JimProvider = ({
  fetchJobs,
  lastUpdated,
  isAnyJobInProgress,
  interval,
}) => {
  const timeout = useRef();
  const prevLastUpdated = useRef();
  const prevIsAnyJobInProgress = useRef();

  useEffect(() => {
    fetchJobs();
  }, [fetchJobs]);

  useEffect(() => {
    if (prevLastUpdated.current !== lastUpdated || (!prevIsAnyJobInProgress.current && isAnyJobInProgress)) {
      prevLastUpdated.current = lastUpdated;
      prevIsAnyJobInProgress.current = isAnyJobInProgress;
      timeout.current = setTimeout(() => fetchJobs(), isAnyJobInProgress ? interval : (interval * 10));
    }
    return () => clearTimeout(timeout.current);
  }, [fetchJobs, lastUpdated, isAnyJobInProgress, interval]);

  return null;
};

JimProvider.defaultProps = {
  interval: 3000,
};

JimProvider.propTypes = {
  fetchJobs: PropTypes.func.isRequired,
  lastUpdated: PropTypes.number.isRequired,
  isAnyJobInProgress: PropTypes.bool.isRequired,
  interval: PropTypes.number,
};

export default connect(state => ({
  lastUpdated: lastUpdatedSelector(state),
  isAnyJobInProgress: isAnyJobInProgressSelector(state),
}), {
  fetchJobs,
})(JimProvider);
